import { atom } from "recoil";

export const selectState = {
  dong: atom({
    key: "selectDongState",
    default: "",
  }),

  ho: atom({
    key: "selectHoState",
    default: "",
  }),

  area: atom({
    key: "selectAreaState",
    default: "",
  }),
};

export const searchTextState = atom({
  key: "searchTextState",
  default: "",
});

export const tableState = {
  userData: atom<any>({
    key: "userData",
    default: [],
  }),

  checkedItems: atom({
    key: "checkedItems",
    default: [],
  }),

  newRowData: atom<any>({
    key: "newRowData",
    default: [],
  }),

  totalPage: atom<any>({
    key: "totalPage",
    default: 0,
  }),

  currentPage: atom({
    key: "currentPage",
    default: 1,
  }),
};
